// key portal tasks
export default {
  NO_TASK: 'no_task',
  HOME: 'home',
  NEW_JOB_REQUEST: 'new_job_request',
  NEW_JOB_REQUEST_FROM_COPY: 'new_job_request_from_copy',
  NEW_JOB_REQUEST_FROM_REPOST: 'new_job_request_from_repost',
  NEW_JOB_REQUEST_FROM_SCRATCH: 'new_job_request_from_scratch',
  NEW_JOB_REQUEST_FROM_TEMPLATE: 'new_job_request_from_template',
  NEW_JOB_REQUEST_TEMPLATES: 'new_job_request_templates',
  EDIT_JOB_REQUEST: 'edit_job_request',
  EDIT_JOB_REQUEST_SECTION: 'edit_job_request',
  EDIT_TEMPLATE: 'edit_template',
  NEW_TEMPLATE: 'new_template',
  JOB_REQUEST_POSTED: 'job_request_posted',
  JOBS_REPORT: 'jobs_report',
  MANAGE_JOBS: 'manage_jobs',
  SUMMARY_REPORT: 'summary_report',
  WONOLOERS: 'workforce_list',
  WORKERS: 'wonoloer_profile',
  JOB_REQUESTS_IMPORT: 'import_jobs_main',
  JOB_REQUEST_IMPORTED_FILE: 'import_jobs_details',
  JOB_REQUEST_DETAILS: 'job_request_details',
  NOTIFICATION_PREFERENCES: 'notification_preferences',
  WANDAS: 'wanda_manager',
  DASHBOARD: 'dashboard',
  MY_COMPANY: 'my_company',
};
